import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbCorrespondencia extends AppService {
  abstract getAllCorrespondencias(filter: AppFilter): Observable<any>;
  abstract saveCorrespondencias(correspondencia: any): Observable<any>;
  abstract getCorrespondencia(id: number): Observable<any>;
  abstract getCorrespondenciasUnidadePessoa(filter: AppFilter): Observable<any>;
  abstract getCorrespondenciasUnidadePessoaV2(filter: AppFilter): Observable<any>;
  abstract gerarRelatorio(filter: AppFilter): Observable<any>;
  abstract getComprovanteCorrespondenciaById(correspondenciaId: number): Observable<any>;
}